import { render } from "./products-main.vue?vue&type=template&id=db45fed2&scoped=true"
import script from "./products-main.vue?vue&type=script&lang=js"
export * from "./products-main.vue?vue&type=script&lang=js"

import "./products-main.vue?vue&type=style&index=0&id=db45fed2&scoped=true&lang=css"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db45fed2"]])

export default __exports__